import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { deleteWorkScheduleSlotRecurrenceModes } from '../delete-work-schedule-slot-recurrence/schema';
import { DeleteAgendaSlotRecurrenceUseForm } from './use-delete-agenda-slot-recurrence-form';

type Props = {
  form: DeleteAgendaSlotRecurrenceUseForm;
};

const DeleteAgendaSlotRecurrenceForm = ({ form }: Props) => {
  const { t } = useTranslation();

  const deleteModeOptions = deleteWorkScheduleSlotRecurrenceModes.map(
    (mode) => {
      return {
        id: mode,
        value: mode,
        label: `delete-agenda-slot-recurrence-form.delete-option.${mode}`,
      };
    },
  );

  return (
    <Form {...form}>
      <form className="grid gap-4">
        <FormField
          control={form.control}
          name="mode"
          render={() => (
            <FormItem>
              {deleteModeOptions.map((mode) => (
                <FormField
                  key={mode.id}
                  name="mode"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={mode.id}
                        className="flex flex-row items-start space-x-3 space-y-0"
                      >
                        <FormControl>
                          <Checkbox
                            checked={field.value === mode.id}
                            onCheckedChange={(checked) => {
                              if (checked) {
                                return field.onChange(mode.id);
                              }
                            }}
                          />
                        </FormControl>
                        <FormLabel className="cursor-pointer font-normal text-sm">
                          {t(mode.label)}
                        </FormLabel>
                      </FormItem>
                    );
                  }}
                />
              ))}
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};

export default DeleteAgendaSlotRecurrenceForm;
